import { css } from 'emotion';
import {
  ISettingsColors,
  ISettingsFonts,
} from '@wix/podcasts-common/dist/settings';
import getFontStyles from '../../../../lib/styles/getFontStyles';

interface IGetStylesArgs {
  colors: ISettingsColors;
  fonts: ISettingsFonts;
}

export default function getStyles({ colors, fonts }: IGetStylesArgs) {
  return {
    episodesWrapper: css({
      backgroundColor: colors.main.episodeListBackgroundColor,
    }),
    noEpisodes: css({
      ...getFontStyles(fonts.main.headerDescriptionFont),
      fontSize: 38,
    }),
  };
}
